'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');

  /********************************
   * Header search (desktop)
   *******************************/
  const search = document.querySelector('.search-desktop');

  if (search) {
    const isTriggerSearch = search.querySelector('.button-nav');
    isTriggerSearch.addEventListener('click', (event) => {
      search.classList.add('show-form-search');

      event.stopPropagation();
      let listener = function ({target}) {
        if (!target.closest('.search-desktop')) {
          search.classList.remove('show-form-search');
          body.removeEventListener('click', listener);
        }
      };
      body.addEventListener('click', listener);
    });
  }

  /********************************
   * Slider: section - why-love-us
   *******************************/
  const sectionWhyLoveUs = document.querySelectorAll('.why-love-us');

  if (sectionWhyLoveUs.length) {
    sectionWhyLoveUs.forEach(section => {
      const sliderContainer = section.querySelector('.swiper-why-love-us');
      const sliderItems = sliderContainer.querySelectorAll('.swiper-slide');

      if (sliderItems.length > 1) {
        const slider = new Swiper(sliderContainer, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      }
    });
  }

  /********************************
   * Slider: section - featured-product
   *******************************/
  const featuredProductSection = document.querySelectorAll('.featured-collection');

  if (featuredProductSection.length) {
    featuredProductSection.forEach(section => {
      const sliderContainer = section.querySelector('.featured-product-container');
      const sliderItems = sliderContainer.querySelectorAll('.product-card-wrapper');

      const sliderInit = () => {
        new Swiper(sliderContainer, {
          loop: true,
          slidesPerView: 1.13,
          spaceBetween: 13,
          navigation: {
            nextEl: ".slider-nav-next",
            prevEl: ".slider-nav-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 2.4,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 40,
            }
          }
        });
      }

      if (sliderItems.length > 4 && window.innerWidth >= 1200) {
        sliderInit();
      } else if (sliderItems.length > 3 && window.innerWidth <= 1199 && window.innerWidth >= 992) {
        sliderInit();
      } else if (sliderItems.length > 1 && window.innerWidth <= 991) {
        sliderInit();
      }
    });
  }

  /********************************
   * Section: Video slider
   *******************************/
  const nodeSlicerSelectors = {
    container: '[js-video-slider="container"]',
    slider: '[js-video-slider="wrapper"]',
    navigation: '[js-video-slider="navigation"]',
    prev: '[js-video-slider="prev"]',
    next: '[js-video-slider="next"]',
    soundBtn: '[js-video-slider="sound"]',
  }

  function initSlider() {
    let slidersContainers = document.querySelectorAll(nodeSlicerSelectors.container);

    slidersContainers.forEach(function (container, index) {
      let sliderEl = container.querySelector(nodeSlicerSelectors.slider)
      let sliderNav = container.querySelector(nodeSlicerSelectors.navigation)

      const videoSlider = new Swiper(sliderEl, {
        slidesPerView: 1.27,
        spaceBetween: 15,
        cssMode: true,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: container.querySelector(nodeSlicerSelectors.next),
          prevEl: container.querySelector(nodeSlicerSelectors.prev),
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesPerView: 2,
          },
          992: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesPerView: 3,
          },
          1200: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            cssMode: false,
            slidesPerView: 4,
            spaceBetween: 15
          },
        }
      });

      videoSlider.on('slideChange', function () {
        sliderEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
          const buttonPlay = slide.querySelector('.play-video');
          if (buttonPlay.classList.contains('active')) {
            buttonPlay.click();
          }
          buttonPlay.classList.remove('active');
        });
      });

      document.querySelectorAll('.play-video').forEach(function (button) {
        button.addEventListener('click', function () {
          button.classList.toggle('active');
          const overlay = sliderEl.querySelector('.overlay');
          if (overlay) {
            overlay.style.display = overlay.style.display === 'none' ? 'block' : 'none';
          }
        });
      });

    })
  }

  if (document.querySelectorAll(nodeSlicerSelectors.container).length) {
    initSlider()
  }

  /********************************
   * Play video
   *******************************/
  const nodeVideoPlaySelectors = {
    container: '[js-big-video="container"]',
    video: '[js-big-video="video"]',
    soundBtn: '[js-big-video="sound"]',
    playBtn: '[js-big-video="play"]',
  }

  function initVideoPlay() {
    const videosSections = document.querySelectorAll(nodeVideoPlaySelectors.container)

    videosSections.forEach(function (section, index) {
      let video = section.querySelector(nodeVideoPlaySelectors.video)
      let playVideoBtn = section.querySelector(nodeVideoPlaySelectors.playBtn)
      let soundVideoBtn = section.querySelector(nodeVideoPlaySelectors.soundBtn)

      if (soundVideoBtn) {
        soundVideoBtn.addEventListener('click', () => {
          if (video.muted) {
            video.muted = false
            soundVideoBtn.classList.add('unmuted')
          } else {
            video.muted = true
            soundVideoBtn.classList.remove('unmuted')
          }
        })
      }

      if (playVideoBtn) {
        playVideoBtn.addEventListener('click', () => {
          if (video.paused) {
            video.play()
            video.muted = false
            playVideoBtn.classList.remove('paused')
          } else {
            video.pause()
            playVideoBtn.classList.add('paused')
          }
        })
      }

      video.onloadeddata = function () {
        playVideoBtn.classList.remove('paused');
      };
    })
  }

  if (document.querySelectorAll(nodeVideoPlaySelectors.container).length) {
    initVideoPlay()
  }

  /********************************
   * Accordion
   *******************************/
  const accordionGroup = document.querySelectorAll('.accordion-wrap');

  if (accordionGroup.length >= 1) {
    accordionGroup.forEach(accordion => {
      if (accordion.classList.contains('open-first-child')) {
        setTimeout(() => {
          const accordionItem = accordion.querySelector('.accordion-item');
          const accordionContent = accordionItem.querySelector('.accordion-description');

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + 22) + "px";
        }, 1300)
      }

      accordion.addEventListener('click', function ({target}) {
        const accordionActive = accordion.querySelector('.accordion-item.active');
        const accordionItem = target.closest('.accordion-item');

        if (!accordionItem) {
          return
        }

        const accordionContent = accordionItem.querySelector('.accordion-description');

        if (accordionItem.classList.contains('active')) {
          accordionItem.classList.remove('active');
          accordionContent.style.height = 0 + 'px';
        } else {
          if (accordionActive) {
            accordionActive.classList.remove('active');
            accordionActive.querySelector('.accordion-description').style.height = 0 + 'px';
          }

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + 22) + "px";
        }
      });
    })
  }

  /********************************
   * Klaviyo Form
   *******************************/
  const klaviyoFormWrap = document.querySelector('.klaviyo-form');
  if (klaviyoFormWrap) {
    const listId = klaviyoFormWrap.dataset.list;
    const companyId = klaviyoFormWrap.dataset.companyId;
    const klaviyoForm = klaviyoFormWrap.querySelector('form');
    const klaviyoFormError = klaviyoFormWrap.querySelector('.subscribe-error');
    const klaviyoFormSuccessful = klaviyoFormWrap.querySelector('.subscribe-successful');

    function submitKlaviyoForm(e) {
      e.preventDefault();
      const emailInput = klaviyoForm.querySelector('.input-email');
      if (!emailInput.value) return;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-07-15'
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        })
      })
          .then(function (response) {
            return response.text();
          })
          .then(function (data) {
            console.log(`data, ${data}`);
            emailInput.value = '';
            klaviyoFormSuccessful.style.display = 'block'
          })
          .catch(function (error) {
            console.error('Error:', error);
            klaviyoFormError.style.display = 'block'
          });
    }

    klaviyoForm.addEventListener('submit', submitKlaviyoForm);
  }

  /********************************
   * PDP - scroll page
   *******************************/
  if (body.getAttribute('template') === 'product') {
    const singleProductSection = document.querySelector('.single-product');
    const stickyProductSection = document.querySelector('.sticky-product');

    if (singleProductSection && stickyProductSection) {
      function checkScrollPosition() {
        const singleProductRect = singleProductSection.getBoundingClientRect();

        if (singleProductRect.bottom < 0) {
          stickyProductSection.classList.add('show');
        } else {
          stickyProductSection.classList.remove('show');
        }
      }

      checkScrollPosition();
      window.addEventListener('scroll', checkScrollPosition);
    }
  }

  /********************************
   * Tabs
   *******************************/
  const tabsWrapper = document.querySelectorAll('#tabs-wrapper');

  if (tabsWrapper.length) {
    tabsWrapper.forEach(tab => {
      const tabBtnGroup = tab.querySelector('.tabs-controller');
      const tabButtons = tab.querySelectorAll('.tab-btn');
      const tabContentItem = tab.querySelectorAll('.tab-content-items');

      tabBtnGroup.addEventListener('click', ({target}) => {
        if (target.classList.contains('tab-btn') && !target.classList.contains('active')) {

          tabButtons.forEach(item => item.classList.remove('active'));
          target.classList.add('active');

          tabContentItem.forEach(item => {
            item.getAttribute('data-tab') === target.getAttribute('data-tab')
                ? item.classList.add('active')
                : item.classList.remove('active')
          });
        }
      });
    });
  }

  /********************************
   * Section: logo-with-description
   *******************************/
  const sectionLogoAndContent = document.querySelectorAll('.logo-with-description');

  if (sectionLogoAndContent.length) {
    sectionLogoAndContent.forEach(section => {
      const sliderContainer = section.querySelector('.slider_init');
      const sliderContainerWrap = section.querySelector('.swiper-container-wrap');

      const slider = new Swiper(sliderContainer, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: ".nav-next",
          prevEl: ".nav-prev",
        },
        breakpoints: {
          768: {
            spaceBetween: 35,
            slidesPerView: 3,
          },
          992: {
            spaceBetween: 75,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 90,
            slidesPerView: 3,
          }
        }
      });

      sliderContainerWrap.classList.add('slider-init')
    });
  }

  /********************************
   * PDP - ingredient sections
   *******************************/
  const pagePDP = body.getAttribute('template');
  const sectionNutritionalAndIngredients = document.querySelector('.nutritional-and-ingredients');

  if (pagePDP === "product" && sectionNutritionalAndIngredients) {
    const inputVariant = document.querySelector(".product-variant-id")

    if (inputVariant) {
      const createIngredientsItem = (name, image) => {
        const ingredientItem = document.createElement('div');
        ingredientItem.classList.add('ingredient-item');

        const ingredientImage = document.createElement('div');
        ingredientImage.classList.add('image-wrap');

        const imageTag = document.createElement('img');
        imageTag.setAttribute('src', image);

        ingredientImage.append(imageTag);

        const ingredientName = document.createElement('div');
        ingredientName.classList.add('ingredient-name');
        ingredientName.innerHTML = name;

        ingredientItem.append(ingredientImage,ingredientName);

        return ingredientItem;
      }

      const createIngredients = (array) => {
        const ingredientsLayout = sectionNutritionalAndIngredients.querySelector('#ingredients-items');
        ingredientsLayout.innerHTML = '';

        array.forEach(item => {
          ingredientsLayout.append(createIngredientsItem(item.name, item.image));
        });
      }

      const createNutritionalRow = (main_row = false, serving_size= '', product_value = '', daily_value = '') => {
        const tableBodyRow = document.createElement('div');
        tableBodyRow.classList.add('table-body-row');
        main_row ? tableBodyRow.classList.add('main-values') : '';

        const tableBodyCol = document.createElement('div');
        tableBodyCol.classList.add('table-body-col');
        tableBodyCol.innerHTML = serving_size;

        const tableBodyColl = document.createElement('div');
        tableBodyColl.classList.add('table-body-col');
        tableBodyColl.innerHTML = product_value;

        const tableBodyColll = document.createElement('div');
        tableBodyColll.classList.add('table-body-col');
        tableBodyColll.innerHTML = daily_value;

        tableBodyRow.append(tableBodyCol, tableBodyColl, tableBodyColll);

        return tableBodyRow;
      }

      const createNutritionalTable = (array) => {
        const tableBodyLayout = sectionNutritionalAndIngredients.querySelector('#nutritional-table');
        tableBodyLayout.innerHTML = '';

        array.forEach(item => {
          tableBodyLayout.append(createNutritionalRow(item.main_row, item.serving_size, item.product_value, item.daily_value));
        });
      }

      /* Page on load */
      window.product_variants.forEach(variant =>  {
        if(+variant.variant_id === +inputVariant.value){
          createIngredients(variant.variant_ingredients);
          createNutritionalTable(variant.nutritional_facts);
        }
      });

      /* observer input variant */
      const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {

          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            window.product_variants.forEach(variant =>{
              if(+variant.variant_id === +inputVariant.value){
                createIngredients(variant.variant_ingredients);
                createNutritionalTable(variant.nutritional_facts);
              }
            });
          }
        });
      });

      observer.observe(inputVariant, { attributes: true });
    }
  }

  /********************************
   * Section - Free shipping bar
   *******************************/
  const sectionFreeShippingBar = document.querySelector('.free-shipping-bar');

  function checkRebuyCart() {
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          const rebuyCart = document.querySelector('#rebuy-cart');
          if (rebuyCart) {

            observer.disconnect();
            if (sectionFreeShippingBar && rebuyCart) {
              freeShippingBar(rebuyCart);
            }
          }
        }
      });
    });

    observer.observe(body, { childList: true, subtree: true });
  }

  const freeShippingBar = (rebuyCart) =>{
    const progressFreeShipping = rebuyCart.querySelector('#rebuy-cart__progress-bar-meter-label');
    const freeShippingContent = sectionFreeShippingBar.querySelector('.free-shipping-content');

    if(!progressFreeShipping){
      return false;
    }

    freeShippingContent.innerHTML = progressFreeShipping.innerHTML;

    const observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          freeShippingContent.innerHTML = progressFreeShipping.innerHTML;
        }
      });
    });

    observer.observe(progressFreeShipping, { childList: true });
  }

  checkRebuyCart();
});